// src/components/Membership/Membership.js

import React from "react";
import "../../styles/ijrr.css";
import "./Membership.css";

export default function Membership() {
  return (
    <section className="membership-section space-pb-80">
      <div className="container text-center">
        <h2 className="original-title golden mb-3">IJRR Membership</h2>

        <p className="ijrr-text mb-5">
        Join the IJRR and become part of a global movement for freedom, identity, and expression. Your membership includes image registration, branding tools, and your own custom flag.
        </p>

        <div className="membership-card">
          <div className="membership-box">
            <h3 className="ijrr-title mb-2">Official Membership</h3>
            {/* Updated Price */}
            <p className="membership-price golden">$19.99</p>
            <p className="ijrr-text">
              Includes registration of your name and image, a one-sided printed flag, an official membership certificate, and a custom sticker.
            </p>
            <ul className="membership-details">
              <li><strong>✔</strong> Personalized name and image registration</li>
              <li><strong>✔</strong> One-sided printed flag (2' x 3', polyester)</li>
              <li><strong>✔</strong> Official IJRR Membership Certificate</li>
              <li><strong>✔</strong> Custom sticker(3" x 3") with your uploaded image</li>
              <li><strong>✔</strong> Access to member-only content and updates</li>
              <li><strong>✔</strong> A place in our global pirate community</li>
            </ul>
            <a href="/customize-membership" className="btn btn-primary mt-3">Buy Now</a>
          </div>
        </div>

        <div className="membership-note mt-5">
          <hr className="divider" />
          <p className="ijrr-text small">
            <strong>Note:</strong> 2' x 3' flag is the standard size, polyester and rectangular in shape.
          </p>
        </div>
      </div>
    </section>
  );
}